import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 3h-4v6h4","key":"svg-0"}],["path",{"d":"M10 6h2.5","key":"svg-1"}],["path",{"d":"M16 21l-4 -8l-4 8l4 -2l4 2","key":"svg-2"}]]

const IconNavigationEast = createReactComponent('outline', 'navigation-east', 'NavigationEast', __iconNode);

export default IconNavigationEast;